import React from "react";

const supScript = (
  item,
  start,
  end,
  letter,
  staticWord,
  replaceWord,
  index
) => {
  let regex = new RegExp(staticWord, "gi");

  let span;

  if (start !== 0 && start !== 1) {
    span = <span>&nbsp;{item.slice(0, start)}</span>;
  } else {
    span = <span>{item.slice(0, start)}</span>;
  }

  return (
    <p className="negative-margin-supscript" key={index}>
      {span}
      {letter}
      <sup>
        {item.slice(start, end).replace(regex, replaceWord)}&nbsp;&nbsp;
      </sup>
      <span>{item.slice(end)}</span>
    </p>
  );
};

const subScript = (
  item,
  start,
  end,
  letter,
  staticWord,
  replaceWord,
  index,
  wordInRow = null,
  startSecond = null,
  endSecond = null,
  letterSecond = null,
  staticWordSecond = null,
  replaceWordSecond = null
) => {
  let regex = new RegExp(staticWord, "gi");
  let regexSecond = new RegExp(staticWordSecond, "gi");

  let span;

  if (start !== 0 && start !== 1) {
    span = <span>&nbsp;{item.slice(0, start)}</span>;
  } else {
    span = <span>{item.slice(0, start)}</span>;
  }

  let returnParagraph = (
    <p className="negative-margin-subscript" key={index}>
      {span}
      {letter}
      <sub>
        {item.slice(start, end).replace(regex, replaceWord)}&nbsp;&nbsp;
      </sub>
      <span>{item.slice(end)}</span>
    </p>
  );

  if (wordInRow) {
    returnParagraph = (
      <p className="negative-margin-subscript" key={index}>
        {span}
        {letter}
        <sub>
          {item.slice(start, end).replace(regex, replaceWord)}
        </sub>
        <span>{item.slice(end, startSecond)}</span>
        <sub>
          {item
            .slice(startSecond, endSecond)
            .replace(regexSecond, replaceWordSecond)}
        </sub>
        <span>{item.slice(endSecond)}</span>
      </p>
    );
  }

  return returnParagraph;
};

//TODO i don't like the height
export const addBreakLines = (text, tag = "p", emptyLineHeight = "1.2rem") => {
  let HtmlTag = tag;

  // Subscript
  return text.split("\n").map((item, index) => {
    if (item.includes("Vᴅᴅ") && item.charAt(0) === "V") {
      return (HtmlTag = subScript(item, 0, 3, "V", "Vᴅᴅ", "DD", index));
    }

    if (item.includes("IDD") && item.charAt(1) === "I") {
      return (HtmlTag = subScript(
        item,
        1,
        4,
        "I",
        "IDD",
        "DD",
        index,
        2,
        15,
        17,
        "V",
        "VDD",
        "DD"
      ));
    }

    if (item.includes("IDD") && item.charAt(0) === "I") {
      return (HtmlTag = subScript(item, 0, 3, "I", "IDD", "DD", index));
    }

    if (item.includes("IDD") && item.charAt(34) === "I") {
      return (HtmlTag = subScript(item, 34, 37, "I", "IDD", "DD", index));
    }

    if (item.includes("Ts") && item.charAt(0) === "T") {
      return (HtmlTag = subScript(item, 0, 2, "T", "Ts", "S", index));
    }

    if (item.includes("Ta") && item.charAt(9) === "T") {
      return (HtmlTag = subScript(item, 9, 11, "T", "Ta", "A", index));
    }
    if (item.includes("Ta") && item.charAt(39) === "T") {
      return (HtmlTag = subScript(item, 39, 41, "T", "Ta", "A", index));
    }

    // Supscript
    if (item.includes("1st") && item.charAt(0) === "1") {
      return (HtmlTag = supScript(item, 0, 3, "1", "1st", "st", index));
    }

    if (item.includes("1st") && item.charAt(6) === "1") {
      return (HtmlTag = supScript(item, 6, 9, "1", "1st", "st", index));
    }

    if (item.includes("1st") && item.charAt(7) === "1") {
      return (HtmlTag = supScript(item, 7, 10, "1", "1st", "st", index));
    }

    return item !== " " ? (
      <HtmlTag key={index}>{item}</HtmlTag>
    ) : (
      <HtmlTag style={{ height: emptyLineHeight }}>&nbsp;</HtmlTag>
    );
  });
};

export default "stupid";
